import React, { useState } from "react";
import Confirm from "../../../../shared/components/confirm";
import { connect } from "react-redux";
import { createFaq, deleteFaq, deletefaqNotActive, hanldeUpdateName } from "../../../../../store/action/faqAction";
import { Link, useNavigate } from "react-router-dom";
import { URL } from "../../../../../routers/constants";
import SlateEditor from "../../../../shared/components/SlateEditor/editor";
import { replaceNavigate, showErrorToasts } from "../../../../../services/helpers/Helper";


const TrTableFaq = ({ faq, deleteFaq, deletefaqNotActive, createFaq, hanldeUpdateName }) => {
   const navigate = useNavigate();
   const [value, setValue] = useState('');
   const [error, setError] = useState(false);
   const [showConfirm, setShowConfirm] = useState(false);
   const [isEdit, setIsEdit] = useState(false);
   const [name, setName] = useState(faq.name);
   const handleConfirm = () => {
      deleteFaq(faq.id, () => setShowConfirm(false))
   }

   const handleCreate = () => {
      if (value.length > 0 && value.length <= 80) {
         setError(false);
         createFaq(value);
      } else {
         showErrorToasts('Giới hạn nội dung câu hỏi từ 1 đến 80 ký tự.');
         setError(true);
      }

   }

   return (
      <React.Fragment>
         <tr className="app-v2-table-tr row-add-ice-breaker">
            {faq.is_actived ?
               <React.Fragment>
                  <td className="app-v2-table-td reset-overflow">
                     <div>
                        {isEdit ?
                           <div className="ice-breaker-editor-name-wrapper input-text-margin-left-0">
                              <div className="input-text input-text-none-scrollbar text-single font-size-14 editor">
                                 <SlateEditor
                                    autoFocus={true}
                                    emoji={true}
                                    maxLength={80}
                                    valueDefault={faq.name}
                                    onBlur={() => setIsEdit(false)}
                                    onChange={setName}
                                 />
                              </div>
                              <div onClick={() => {
                                 hanldeUpdateName(faq, name);
                              }}>
                                 <button className="btn btn-icon-only btn-update-ice-Breaker">
                                    <div className="svg-next-icon mr5 ic-save-2">
                                    </div>
                                 </button>
                              </div>
                           </div>
                           :
                           <div className="ice-breaker-name-display" onClick={() => setIsEdit(true)}><span>{faq.name}</span></div>

                        }
                     </div>
                  </td>
                  <td className="app-v2-table-td ice-breaker-msg-wrapper">
                     <div>
                        <div className="reply-content-mgs">
                           <div>
                              <span className="text-muted">Gửi</span>
                           </div>
                           <div>
                              <Link to={replaceNavigate(URL.CHAT_ASSISTANT_MESSENGER_SETTINGS_FAQ_FLOW_EDIT, faq.id)}>
                                 <span className="d-inline-block border-bottom2 ellipsis" style={{ maxWidth: '100%' }}>
                                    {faq.answer}
                                 </span>
                              </Link>
                           </div>
                        </div>
                     </div>
                  </td>
                  <td className="app-v2-table-td text-right-i">
                     <div>
                        <button className="btn btn-remove-ice-breaker" onClick={() => setShowConfirm(true)}>
                           <div className="svg-next-icon ic-recyclebin">
                           </div>
                        </button>
                     </div>
                  </td>
               </React.Fragment>
               :
               <React.Fragment>
                  <td className="app-v2-table-td reset-overflow app-v2-table-td-width" colSpan="2">
                     <div className={`input-text input-text-none-scrollbar text-single font-size-14 editor ${error && "border-error"}`} >
                        <SlateEditor
                           emoji={true}
                           placeholder={"Nhập nội dung câu hỏi tại đây (độ dài không quá 80 ký tự)"}
                           onChange={v => {
                              setValue(v);
                              setError(false);
                           }}
                           maxLength={80}
                        />
                     </div>
                  </td>
                  <td className="app-v2-table-td">
                     <div className="ice-breaker-btn-create-wrapper">
                        <div>
                           <button className="btn btn-default" onClick={deletefaqNotActive}>Huỷ</button>
                        </div>
                        <div>
                           <button className="btn btn-primary app-v2-btn-icon" onClick={handleCreate}>
                              <div className="svg-next-icon ic-plus" style={{ backgroundColor: 'white' }}>
                              </div>
                              Tạo
                           </button>
                        </div>
                     </div>
                  </td>
               </React.Fragment>
            }
         </tr>
         {showConfirm &&
            <Confirm
               onClose={() => setShowConfirm(false)}
               onConfirm={handleConfirm}
               isShowButtonLoading={true}
            >
               <h3 className="text-center app-v2-popup-title">
                  Xóa câu hỏi <span className="text-danger">{faq.name}</span>?
               </h3>
            </Confirm>
         }
      </React.Fragment>
   )
}

const mapStateToProps = (state) => {
   return {

   }
}

export default connect(mapStateToProps, {
   deleteFaq,
   deletefaqNotActive,
   createFaq,
   hanldeUpdateName
})(TrTableFaq);